import React, { Component } from 'react';
import { Input, Modal, Button, Select, Icon } from 'antd';
import * as eChartCommon from '../eChartCommon';
import * as eChartProxy from '../eChartProxy';
import SvgIcon from 'SvgIcon';
import _ from 'lodash';

const Option = Select.Option;
let ConvenientQuery = null;
let Sortable = null;
if (process.env.__CLIENT__) Sortable = require('react-sortablejs');
export default class eChartPanelSetWaittingTask extends React.Component {
  constructor(props) {
    super(props);
    eChartCommon.LogChartInfo("eChartPanelSetWaittingTask constructor ", "", 900)
    ConvenientQuery = require('../../filter').default;

    this.colEle = props.colEle;
    this.initState(props.colEle.panelWaittingTaskConfig);
  }

  initState(panelWaittingTaskConfig) {
    panelWaittingTaskConfig = panelWaittingTaskConfig || {};
    let taskArray = [];
    if (panelWaittingTaskConfig.taskArray) {
      taskArray = _.cloneDeep(panelWaittingTaskConfig.taskArray);
    }
    let taskColNum = panelWaittingTaskConfig.taskColNum || 3;
    if (taskArray.length == 0) {
      taskArray.push(this.getDefaultTaskConfig(taskArray));
    }
    else {
      taskArray.forEach((task) => {
        task.taskModel = undefined
      })
    }
    let curTaskId = taskArray[0].taskId;
    this.state = {
      curTaskId,
      enterTaskId: "",
      taskArray,
      taskColNum,
      businessTargetList: []
    };
  }


  getDefaultTaskConfig(taskArray) {
    let displayName;
    for (var i = 1; i < 1000; i++) {
      displayName = "待办名称" + i;
      let index = _.findIndex(taskArray, function (o) { return o.displayName == displayName });
      if (index < 0) {
        i = 1000;
      }
    }
    return {
      displayName,
      taskModel: undefined,
      taskId: cb.utils.getNewGuid(),
      taskName: "",
      taskBillNum: "",
      taskFilterId: "",
      taskSolutionId: "",
      taskCondition: {}
    };
  }
  componentWillReceiveProps(nextProps) {
    eChartCommon.LogChartInfo("eChartPanelSetWaittingTask componentWillReceiveProps", "", 900);
  }

  render() {
    eChartCommon.LogChartInfo("eChartPanelSetWaittingTask render ", "", 900)
    let self = this;

    let content = self.getCardContent();
    return <Modal
      className="clsSetWaittingTask_Modal"
      title="待办设置"
      onOk={(e) => self.doFunc(true)}
      onCancel={(e) => self.doFunc(false)}
      visible={true}
    >
      {content}
    </Modal>;
  }

  getCurTask(taskId) {
    let self = this;
    taskId = taskId || self.state.curTaskId;
    let curTasks = _.filter(self.state.taskArray, function (o) { return o.taskId == taskId })
    if (curTasks && curTasks.length > 0) {
      return curTasks[0];
    } else {
      cb.utils.alert('没找到当前待办任务节点，需要检查代码！', 'warning');
    }
  }
  selectTask(taskId) {
    let task = this.getCurTask();
    if (task.taskFilterId) {
      // this.triggerFilter(task);
    }
    this.setState({ curTaskId: taskId });
  }
  addTask() {
    let self = this;
    let taskArray = self.state.taskArray;
    taskArray.push(this.getDefaultTaskConfig(taskArray));
    self.setState({ taskArray, curTaskId: taskArray[taskArray.length - 1].taskId });
  }
  //拖拽排序
  dragOrder(items) {
    debugger
    console.log("------------ " + JSON.stringify(items))

    let self = this;
    let taskArray = self.state.taskArray;
    let newTaskArray = [];
    items.forEach((dataid) => {
      let tmp = _.find(taskArray, function (o) {
        return o.taskId == dataid
      })
      if (tmp) {
        newTaskArray.push(tmp)
      }
    })
    self.setState({ taskArray: newTaskArray });
    // let { operatorValue } = this.state;
    // let afterDragItems = [], copyDrag = [];
    // items.forEach(function (ele) {
    //   operatorValue.forEach(function (val, index) {
    //     if (index == ele) {
    //       afterDragItems.push(val)
    //     }
    //   })
    // })
    // this.setState({ operatorValue: afterDragItems })
  }

  removeTask(taskId) {
    let self = this;
    let taskArray = self.state.taskArray;
    if (taskArray.length > 1) {
      cb.utils.confirm("确定删除吗？", () => {
        let index = _.findIndex(taskArray, function (o) { return o.taskId == taskId })
        if (index >= 0) {
          taskArray.splice(index, 1);
          if (index >= taskArray.length) {
            index = index - 1;
          }
          let curTaskId = taskArray[index].taskId;
          self.setState({ taskArray, curTaskId });
        }
      })
    }
    else {
      cb.utils.alert('请至少保留一个待办任务。', 'warning');
    }
  }
  onTextMouseEnter(bEnter, taskId) {
    if (bEnter) {
      this.setState({ "enterTaskId": taskId })
    }
    else {
      this.setState({ "enterTaskId": "" })
    }
  }

  displayNameChange(e) {
    let taskArray = this.state.taskArray;
    let curTask = this.getCurTask();
    if (e.target.value.length < 20) {
      curTask.displayName = e.target.value;
    }
    this.setState({ taskArray });
  }
  selectBusinessTarget(billnum) {

    let self = this;
    let businessTarget = _.filter(self.state.businessTargetList, function (o) { return o.billnum == billnum });
    if (businessTarget && businessTarget.length > 0) {
      businessTarget = businessTarget[0];
      let taskArray = self.state.taskArray;
      let curTask = self.getCurTask();
      curTask.taskName = businessTarget.name;
      curTask.taskBillNum = businessTarget.billnum;
      curTask.taskMenuCode = businessTarget.menu_code;
      curTask.taskFilterId = businessTarget.filterId;
      curTask.taskSolutionId = businessTarget.solutionId;
      curTask.taskModel = undefined;
      self.setState({
        taskArray
      });
    }
  }


  getCardContent() {
    let self = this;
    let curTask = self.getCurTask();
    let filter;
    if (curTask.taskFilterId) {
      self.checkTaskFilterModel(curTask);
      filter = <ConvenientQuery
        panelType={2}
        model={curTask.taskModel}
        cols={1}
        filterDisplayType="waittingTask"
        config={{ classname: "clsSetWaittingTask_Filter" }}
      />;
    }
    filter = <div
      key={curTask.taskFilterId}
      className={"clsSetWaittingTask_FilterOuter"}
      style={{ display: '' }}
    >
      {filter}
    </div>

    let businessTargetOptions = [];
    self.state.businessTargetList.forEach((ele) => {
      businessTargetOptions.push(<Option value={ele.billnum}>{ele.name}</Option>);
    });
    let taskOptions = [];
    self.state.taskArray.forEach((ele) => {
      let isSelected = (ele.taskId == curTask.taskId);
      let isEntereed = (ele.taskId == self.state.enterTaskId)
      taskOptions.push(<div
        className={"clsSetWaittingTask_Task "
          + (isSelected ? " clsSetWaittingTask_Task_Selected" : "")
          + (isEntereed ? " clsSetWaittingTask_Task_Entered" : "")
        }
        onMouseEnter={() => this.onTextMouseEnter(true, ele.taskId)}
        onMouseLeave={() => this.onTextMouseEnter(false, ele.taskId)}
        data-id={ele.taskId}
      >
        {/* <Icon
          className="clsSetWaittingTask_Task_0"
          type="delete"
        >
        </Icon> */}
         
        <Icon type="tuodong" />
        <div
          className="clsSetWaittingTask_Task_1"
          onClick={() => { self.selectTask(ele.taskId) }}
        >
          {ele.displayName}
        </div>
        <div className="clsSetWaittingTask_Task_2">
          {/* <SvgIcon style={{ display: (isEntereed ? "" : "none"), width: '18px', height: '18px' }}
            onClick={() => self.removeTask(ele.taskId)} className="icon-delete" type="delete" /> */}
          <Icon style={{ display: (isEntereed ? "" : "none"), width: '18px', height: '18px' }}
            onClick={() => self.removeTask(ele.taskId)} type="delete" />
        </div>
      </div>);
    });
    let content =
      <div className="clsSetWaittingTask_Outer">
        <div className="clsSetWaittingTask_left">
          <div className="clsSetWaittingTask_left_Top">
            <div className="clsSetWaittingTask_left_Top_1" >
              <Select
                value={self.state.taskColNum}
                onSelect={(taskColNum) => self.setState({ taskColNum })}
              >
                <Option value={1}>1</Option>
                <Option value={2}>2</Option>
                <Option value={3}>3</Option>
                <Option value={4}>4</Option>
                <Option value={5}>5</Option>
                <Option value={6}>6</Option>
                <Option value={7}>7</Option>
                <Option value={8}>8</Option>
              </Select>
            </div>
            <div className="clsSetWaittingTask_left_Top_2" >列展示</div>
            <div className="clsSetWaittingTask_left_Top_3" onClick={() => { self.addTask() }} >新增</div>

          </div>
          <div className="clsSetWaittingTask_Tasks" >

            <Sortable
              tag='div'
              options={{
                group: {
                  name: 'shared',
                  pull: false,
                  put: false
                },
                animation: 150,
                ghostClass: 'blue-background-class',
                scroll: true,
                scrollSensitivity: 10,
                scrollSpeed: 30,
              }}
              onChange={(items) => {
                this.dragOrder(items)
              }}

            >
              {taskOptions}
            </Sortable>
{/* 
            <Sortable
              // tag="div"
              options={{
                group: {
                  // name: 'shared',
                  // pull: false,
                  put: true
                },
                axis: "y"
              }}
              onChange={(items) => {
                self.dragOrder(items)
              }}
            >
              {taskOptions}
            </Sortable> */}

          </div>
        </div>
        <div className="clsSetWaittingTask_right" >
          <div className="clsSetWaittingTask_right_item" >
            <div className="clsSetWaittingTask_right_item_1" >待办名称</div>
            <div className="clsSetWaittingTask_right_item_2" >
              <Input value={curTask.displayName}
                onChange={e => this.displayNameChange(e)}
                placeholder="请录入名称"
              />
            </div>
          </div>
          <div className="clsSetWaittingTask_right_item" >
            <div className="clsSetWaittingTask_right_item_1" >来源单据</div>
            <div className="clsSetWaittingTask_right_item_2" >
              <Select
                value={curTask.taskBillNum}
                onSelect={(billnum) => self.selectBusinessTarget(billnum)}
              >
                {businessTargetOptions}
              </Select>
            </div>
          </div>
          <div className="clsSetWaittingTask_right_item" >
            <div className="clsSetWaittingTask_right_item_3" >过滤条件</div>

          </div>
          <div className="clsSetWaittingTask_right_item" >
            {filter}
          </div>
        </div>
      </div>;

    return content;
  }

  getBusinessTargetList() {

    let param = {};
    let callback = (json) => {
      if (json.code === 200) {
        if (json.data) {
          this.setState({ businessTargetList: json.data });
        }
      }
    }

    eChartProxy.doProxy('/billView/getBillViewList', 'GET', param, callback);
  }

  // getGroupSchema(billnum) {
  //   if (billnum) {
  //     let param = { billnum: billnum };
  //     let callback = (json) => {
  //       if (json.code === 200) {
  //         if (json.data) {
  //           let groupSchemaArray = json.data || [];
  //           if (this.state.panelType == 3) {
  //             groupSchemaArray = _.filter(groupSchemaArray, function (o) { return o.isMobile == true });
  //           }
  //           this.setState({ groupSchemaArray });
  //         }
  //       }
  //     }
  //     eChartProxy.doProxy(eChartProxy.url.getGroupSchema, 'GET', param, callback);
  //   }
  //   else {
  //     this.setState({ groupSchemaArray: [] });
  //   }
  // }

  checkTaskFilterModel(curTask) {
    if (curTask.taskModel == undefined) {
      curTask.taskModel = new cb.models.SimpleModel({});
      curTask.taskModel.getParams = function () {
        let tmp = {
          filterId: curTask.taskFilterId,
          condition: curTask.taskCondition,
          solutionId: curTask.taskSolutionId,
          isInDesign: true,
          isInPanel: true,
          isWaittingTask:true
        };
        return tmp;
      };
      curTask.taskModel.on('filterClick', function (args) {
        // self.state.condition = args.condition;
        // curTask.taskCondition = args.condition;
        curTask.taskCondition = JSON.parse(JSON.stringify(args.condition));
        // let filterModel = curTask.taskModel.getCache('FilterViewModel');
        // let predicateValue = filterModel && filterModel.getCache('predicateValue');
        // // info.predicateValue = predicateValue;
        // let condition = eChartCommon.trimPredicateValue(predicateValue, args.condition);
        // curTask.taskCondition = JSON.parse(JSON.stringify(condition));
        let filterModel = curTask.taskModel.getCache('FilterViewModel');
        let predicateValue = filterModel && filterModel.getCache('predicateValue');
        curTask.predicateValue = predicateValue;
        let condition = eChartCommon.trimPredicateValue(predicateValue, args.condition);
        curTask.taskCondition = JSON.parse(JSON.stringify(condition));
      });
      curTask.taskModel.setName("待办任务设置1234");
    }
  }

  triggerFilter(curTask) {
    let taskArray;
    if (curTask)
      taskArray = [curTask];
    else
      taskArray = this.state.taskArray;
    taskArray.forEach((task) => {
      let taskModel = task.taskModel;
      if (taskModel) {
        taskModel.execute('eChartPanel_GetCondition');
      }
    })
  }

  doFunc(bOK) {
    // let filterModel = this.taskModel.getCache('FilterViewModel');
    // let predicateValue = filterModel && filterModel.getCache('predicateValue');
    //  info.condition = eChartCommon.trimPredicateValue(predicateValue, this.state.condition);
    // this.taskModel.execute('eChartPanel_GetCondition');
    let errStr = "";
    let info = {};
    this.triggerFilter();
    if (bOK) {
      info.taskColNum = this.state.taskColNum;
      info.taskArray = this.state.taskArray;
      if (_.isNull(info.taskColNum) || info.taskColNum.toString().trim() == "") {
        errStr = "请输入列数。"
      }
      info.taskArray.forEach((task, index) => {
        if (task.displayName == "" && errStr == "") {
          errStr = "任务名称不可为空，请检查第" + (index + 1) + "行的设置";
        }
        else if (task.taskBillNum == "" && errStr == "") {
          errStr = "任务" + task.displayName + "来源单据不可为空，请检查第" + (index + 1) + "行待办任务的设置";
        }
      })
      info.taskArray.forEach((task) => {
        task.taskModel = undefined
      })
    }
    if (errStr) {
      cb.utils.alert(errStr);
    }
    else {
      this.props.doFunc(bOK, info);
    }
  }

  componentDidMount() {
    this.getBusinessTargetList();
    // if (this.state.billnum)
    //   this.getGroupSchema(this.state.billnum);
  }
}





// WEBPACK FOOTER //
// ./src/yxyweb/common/components/echart/panel/eChartPanelSetWaittingTask.jsx